module.exports = __webpack_public_path__ + "static/media/4_of_diamonds.19e85669.png";